/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * One entry of DataImport.state_steps.
 * @export
 * @interface StateStep
 */
export interface StateStep {
    /**
     * 
     * @type {string}
     * @memberof StateStep
     */
    state: string;
    /**
     * 
     * @type {Date}
     * @memberof StateStep
     */
    enteredAt: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof StateStep
     */
    leftAt: Date | null;
    /**
     * 
     * @type {number}
     * @memberof StateStep
     */
    durationSeconds: number | null;
    /**
     * 
     * @type {string}
     * @memberof StateStep
     */
    actionStatus: string | null;
}

/**
 * Check if a given object implements the StateStep interface.
 */
export function instanceOfStateStep(value: object): value is StateStep {
    if (!('state' in value) || value['state'] === undefined) return false;
    if ((!('enteredAt' in (value as Record<string, any>)) && !('entered_at' in (value as Record<string, any>))) || ((value as Record<string, any>)['enteredAt'] === undefined && (value as Record<string, any>)['entered_at'] === undefined)) return false;
    if ((!('leftAt' in (value as Record<string, any>)) && !('left_at' in (value as Record<string, any>))) || ((value as Record<string, any>)['leftAt'] === undefined && (value as Record<string, any>)['left_at'] === undefined)) return false;
    if ((!('durationSeconds' in (value as Record<string, any>)) && !('duration_seconds' in (value as Record<string, any>))) || ((value as Record<string, any>)['durationSeconds'] === undefined && (value as Record<string, any>)['duration_seconds'] === undefined)) return false;
    if ((!('actionStatus' in (value as Record<string, any>)) && !('action_status' in (value as Record<string, any>))) || ((value as Record<string, any>)['actionStatus'] === undefined && (value as Record<string, any>)['action_status'] === undefined)) return false;
    return true;
}

export function StateStepFromJSON(json: any): StateStep {
    return StateStepFromJSONTyped(json, false);
}

export function StateStepFromJSONTyped(json: any, ignoreDiscriminator: boolean): StateStep {
    if (json == null) {
        return json;
    }
    return {
        
        'state': json['state'],
        'enteredAt': (json['entered_at'] == null ? null : new Date(json['entered_at'])),
        'leftAt': (json['left_at'] == null ? null : new Date(json['left_at'])),
        'durationSeconds': json['duration_seconds'],
        'actionStatus': json['action_status'],
    };
}

export function StateStepToJSON(json: any): StateStep {
    return StateStepToJSONTyped(json, false);
}

export function StateStepToJSONTyped(value?: StateStep | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'state': value['state'],
        'entered_at': value['enteredAt'] == null ? value['enteredAt'] : value['enteredAt'].toISOString(),
        'left_at': value['leftAt'] == null ? value['leftAt'] : value['leftAt'].toISOString(),
        'duration_seconds': value['durationSeconds'],
        'action_status': value['actionStatus'],
    };
}

